import footerTemplate from "../templates/footer-leaf";
import {
  updateClassNames,
  appendCountryLanguage,
  hideElementInIframe,
  initializeLightbox,
  getCountry,
  getLanguage,
} from "./GeneralHelpers";

class LeafFooter extends HTMLElement {
  constructor() {
    super();
    this.root = this.attachShadow({ mode: "open" });
  }

  connectedCallback() {
    this.country = getCountry(this);
    this.language = getLanguage(this);

    // Add footer content to body
    this.root.appendChild(footerTemplate.content.cloneNode(true));

    updateClassNames(this.root, ".LEAF", this.country, this.language);
    appendCountryLanguage(this.root, this.country, this.language);
    hideElementInIframe(this.root, ".LEAF");
    initializeLightbox(document);
    initializeLightbox(this.root);
  }
}

export default LeafFooter;
